export const Uparrow = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12.818"
        height="11.99"
        viewBox="0 0 12.818 11.99"
      >
        <g
          id="Icon_feather-arrow-up"
          data-name="Icon feather-arrow-up"
          transform="translate(1.414 1)"
        >
          <path
            id="Path_3"
            data-name="Path 3"
            d="M18,7.5v9.99"
            transform="translate(-13.005 -7.5)"
            fill="none"
            stroke="#014cec"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path
            id="Path_4"
            data-name="Path 4"
            d="M7.5,7.5l4.995,4.995L17.49,7.5"
            transform="translate(-7.5 -2.505)"
            fill="none"
            stroke="#014cec"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
      </svg>
    );
  };
  export const Telegram = () => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="la:telegram" clipPath="url(#clip0_570_1040)">
          <path
            id="Vector"
            d="M30.1592 2.25496C29.7887 2.28191 29.4251 2.36884 29.0824 2.51234H29.0778C28.7489 2.64276 27.185 3.30063 24.8074 4.29783L16.2873 7.88613C10.1737 10.4599 4.16397 12.9945 4.16397 12.9945L4.23553 12.9668C4.23553 12.9668 3.82119 13.103 3.38837 13.3996C3.12099 13.5697 2.8909 13.7924 2.71203 14.054C2.49967 14.3656 2.32885 14.8423 2.39233 15.3351C2.4962 16.1684 3.03635 16.6682 3.42415 16.944C3.81657 17.2233 4.19052 17.3538 4.19052 17.3538H4.19975L9.83555 19.2524C10.0883 20.0637 11.5529 24.8789 11.905 25.9881C12.1127 26.6506 12.3147 27.0649 12.5675 27.3811C12.6898 27.5427 12.8329 27.6778 13.0049 27.7863C13.0943 27.8383 13.1896 27.8793 13.2888 27.9086L13.2311 27.8947C13.2484 27.8994 13.2623 27.9132 13.275 27.9178C13.3211 27.9305 13.3523 27.9351 13.4111 27.9444C14.3033 28.2145 15.0201 27.6604 15.0201 27.6604L15.0605 27.6281L18.3879 24.5984L23.9648 28.8769L24.0918 28.9312C25.254 29.4413 26.4313 29.1574 27.0534 28.6565C27.6801 28.1521 27.9236 27.5069 27.9236 27.5069L27.964 27.4031L32.2737 5.32504C32.396 4.78027 32.4272 4.27013 32.2921 3.77499C32.1529 3.27388 31.8314 2.8429 31.3907 2.56658C31.0207 2.34165 30.5917 2.23308 30.1592 2.25496ZM30.0427 4.621C30.0381 4.69371 30.0519 4.68563 30.0196 4.82528V4.83798L25.7503 26.6863C25.7319 26.7175 25.7007 26.7856 25.6153 26.8537C25.5253 26.9252 25.4537 26.9703 25.0786 26.8214L18.2575 21.5918L14.1371 25.3475L15.0027 19.819L26.1474 9.43156C26.6067 9.00452 26.4532 8.91449 26.4532 8.91449C26.4855 8.3905 25.7596 8.76099 25.7596 8.76099L11.7064 17.4669L11.7018 17.4438L4.96612 15.1758V15.1712L4.94881 15.1678C4.96061 15.1638 4.97218 15.1592 4.98343 15.1539L5.02037 15.1354L5.05614 15.1227C5.05614 15.1227 11.0705 12.5882 17.1841 10.0144C20.245 8.72521 23.3289 7.42677 25.7007 6.42496C27.1073 5.83287 28.5154 5.24425 29.925 4.65908C30.0196 4.62215 29.9746 4.621 30.0427 4.621Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_570_1040">
            <rect
              width="31.9013"
              height="31.9013"
              fill="white"
              transform="translate(0.478516 0.106445)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  };
  export const Facebook = () => {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 33 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="facebook">
          <path
            id="Vector (Stroke)"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.2275 5.21206C17.7283 5.21212 17.2341 5.31111 16.7734 5.50332C16.3127 5.69554 15.8946 5.97718 15.5434 6.33196C15.1922 6.68674 14.9148 7.10761 14.7273 7.57025C14.5397 8.03289 14.4457 8.52812 14.4508 9.02731L14.4591 9.87089L14.4591 9.90047L14.3986 14.5425C14.3894 15.2475 13.8153 15.8142 13.1103 15.8142H9.79458V18.1286H13.1708C13.8824 18.1286 14.4592 18.7054 14.4592 19.417V27.1011H17.5327V19.417C17.5327 18.7054 18.1095 18.1286 18.8211 18.1286H22.1003L22.4565 15.8142H18.8205C18.1089 15.8142 17.5321 15.2373 17.5321 14.5257V10.0833C17.5321 8.67142 18.6766 7.52843 20.0869 7.52843H22.6699V5.21206H18.2275C18.2275 5.21206 18.2275 5.21206 18.2275 5.21206ZM15.7812 3.1252C16.5562 2.80184 17.3876 2.63532 18.2274 2.63525H23.9583C24.6699 2.63525 25.2467 3.21209 25.2467 3.92366V8.81683C25.2467 9.5284 24.6699 10.1052 23.9583 10.1052H20.1089V13.2373H23.9583C24.3342 13.2373 24.6914 13.4015 24.9362 13.6868C25.1809 13.9722 25.2889 14.3501 25.2317 14.7217L24.4791 19.6129C24.3824 20.2414 23.8416 20.7054 23.2057 20.7054H20.1095V28.3895C20.1095 29.1011 19.5327 29.6779 18.8211 29.6779H13.1708C12.4592 29.6779 11.8824 29.1011 11.8824 28.3895V20.7054H8.50618C7.79461 20.7054 7.21777 20.1286 7.21777 19.417V14.5257C7.21777 13.8142 7.79461 13.2373 8.50618 13.2373H11.8386L11.8823 9.88165L11.8741 9.05318C11.8741 9.05313 11.8741 9.05323 11.8741 9.05318C11.8657 8.21351 12.0238 7.38035 12.3392 6.60215C12.6547 5.82391 13.1214 5.11592 13.7122 4.51912C14.303 3.92232 15.0062 3.44855 15.7812 3.1252Z"
            fill="white"
          />
        </g>
      </svg>
    );
  };
  export const Instagram = () => {
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 33 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="instagram">
          <path
            id="shape"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5286 2.86353C12.9186 2.86353 12.4659 2.87883 11.0482 2.94351C9.63338 3.00804 8.66713 3.23276 7.82164 3.56138C6.94756 3.90102 6.20628 4.35552 5.46728 5.09448C4.72832 5.83348 4.27382 6.57476 3.93418 7.44884C3.60557 8.29432 3.38085 9.26058 3.31632 10.6754C3.25163 12.0931 3.23633 12.5458 3.23633 16.1558C3.23633 19.7657 3.25163 20.2184 3.31632 21.6361C3.38085 23.0509 3.60557 24.0172 3.93418 24.8627C4.27382 25.7367 4.72832 26.478 5.46728 27.217C6.20628 27.956 6.94756 28.4105 7.82164 28.7502C8.66713 29.0787 9.63338 29.3035 11.0482 29.368C12.4659 29.4327 12.9186 29.448 16.5286 29.448C20.1385 29.448 20.5912 29.4327 22.0089 29.368C23.4237 29.3035 24.39 29.0787 25.2355 28.7502C26.1096 28.4105 26.8508 27.956 27.5898 27.217C28.3288 26.478 28.7833 25.7367 29.123 24.8627C29.4515 24.0172 29.6763 23.0509 29.7408 21.6361C29.8055 20.2184 29.8208 19.7657 29.8208 16.1558C29.8208 12.5458 29.8055 12.0931 29.7408 10.6754C29.6763 9.26058 29.4515 8.29432 29.123 7.44884C28.7833 6.57476 28.3288 5.83348 27.5898 5.09448C26.8508 4.35552 26.1096 3.90102 25.2355 3.56138C24.39 3.23276 23.4237 3.00804 22.0089 2.94351C20.5912 2.87883 20.1385 2.86353 16.5286 2.86353ZM16.5296 5.25715C20.0787 5.25715 20.4991 5.27071 21.9007 5.33466C23.1967 5.39375 23.9005 5.61029 24.3689 5.79233C24.9894 6.03346 25.4322 6.32149 25.8973 6.78666C26.3624 7.25177 26.6505 7.69456 26.8916 8.31501C27.0736 8.78339 27.2902 9.4872 27.3493 10.7832C27.4132 12.1848 27.4268 12.6052 27.4268 16.1544C27.4268 19.7036 27.4132 20.124 27.3493 21.5256C27.2902 22.8216 27.0736 23.5254 26.8916 23.9938C26.6505 24.6142 26.3624 25.057 25.8973 25.5221C25.4322 25.9873 24.9894 26.2753 24.3689 26.5164C23.9005 26.6985 23.1967 26.915 21.9007 26.9741C20.4993 27.0381 20.079 27.0516 16.5296 27.0516C12.9801 27.0516 12.5598 27.0381 11.1583 26.9741C9.86236 26.915 9.15855 26.6985 8.69017 26.5164C8.06972 26.2753 7.62693 25.9873 7.16182 25.5221C6.69671 25.057 6.40862 24.6142 6.16749 23.9938C5.98545 23.5254 5.76891 22.8216 5.70982 21.5256C5.64587 20.124 5.63231 19.7036 5.63231 16.1544C5.63231 12.6052 5.64587 12.1848 5.70982 10.7832C5.76891 9.4872 5.98545 8.78339 6.16749 8.31501C6.40862 7.69456 6.69665 7.25177 7.16182 6.78666C7.62693 6.32149 8.06972 6.03346 8.69017 5.79233C9.15855 5.61029 9.86236 5.39375 11.1583 5.33466C12.56 5.27071 12.9804 5.25715 16.5296 5.25715ZM16.5299 20.5883C14.0828 20.5883 12.0991 18.6046 12.0991 16.1576C12.0991 13.7105 14.0828 11.7268 16.5299 11.7268C18.9769 11.7268 20.9606 13.7105 20.9606 16.1576C20.9606 18.6046 18.9769 20.5883 16.5299 20.5883ZM16.5288 9.3305C12.759 9.3305 9.70305 12.3865 9.70305 16.1563C9.70305 19.926 12.759 22.982 16.5288 22.982C20.2986 22.982 23.3545 19.926 23.3545 16.1563C23.3545 12.3865 20.2986 9.3305 16.5288 9.3305ZM23.6247 10.6541C24.5056 10.6541 25.2198 9.94005 25.2198 9.05911C25.2198 8.17817 24.5056 7.46401 23.6247 7.46401C22.7438 7.46401 22.0296 8.17817 22.0296 9.05911C22.0296 9.94005 22.7438 10.6541 23.6247 10.6541Z"
            fill="white"
          />
        </g>
      </svg>
    );
  };
  export const Twitter = () => {
    return (
      <svg
        width="12"
        height="12"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.0133 11.0626L25.8485 0.0532227H23.5176L14.978 9.61229L8.15716 0.0532227H0.290039L10.6045 14.5084L0.290039 26.0532H2.6209L11.6393 15.9585L18.8424 26.0532H26.7095L16.0127 11.0626H16.0133ZM12.821 14.6356L11.7758 13.1962L3.46064 1.74282H7.04067L13.7508 10.9862L14.7958 12.4256L23.5187 24.4404H19.9391L12.821 14.6362V14.6356Z"
          fill="white"
        />
      </svg>
    );
  };